(function(angular) {
    'use strict';

    angular.module('onvio.reports')
        .config(['$stateProvider', function($stateProvider) {
            $stateProvider.state('onvio-usage', {
                url: '/onvio-usage',
                templateUrl: 'reports/onvio-usage/onvio-usage.html',
                controller: 'onvio.reports.onvioUsageCtrl as vm'
            });

            $stateProvider.state('employee-portal-documents', {
                url: '/employee-portal-documents',
                templateUrl: 'reports/employee-portal-documents/employee-portal-documents.html',
                controller: 'onvio.reports.employeePortalDocumentsCtrl as vm',
                resolve: {
                    permission: ['$state', 'bmPermission', function($state, bmPermission) {
                        bmPermission.has('Reports.BREmployeePortal').then(function() {
                            angular.noop();
                        }).catch(function() {
                            $state.go('notfound', {}, {
                                location: 'replace'
                            });
                        });
                    }]
                }
            });

            $stateProvider.state('firm-management-reports-tree', {
                url: '/firm-management-reports-tree',
                templateUrl: 'reports/firm-management-reports/firm-management-reports-main.html',
                controller: 'onvio.reports.firmManagementReports.FirmManagementReportsListController as vm',
                resolve: {
                    'resolve.translationsLoaded': [
                        '$translate',
                        function($translate) {
                            // #WORKAROUND ensures all translations are loaded before the controller runs.
                            return $translate('Bluemoon.Practice.Common.ErrorHandler.GenericValidationError');
                        }
                    ],
                    // permission: ['$state', 'bmLicense', function($state, bmLicense) {
                    //     bmLicense.has('Internal.Internal').then(function() {
                    //         angular.noop();
                    //     }).catch(function() {
                    //         $state.go('notfound', {}, { location: 'replace' });
                    //     });
                    // }]
                }
            });

            $stateProvider.state('firm-management-reports', {
                url: '/firm-management-reports',
                templateUrl: 'reports/firm-management-reports/firm-management-reports.html',
                controller: 'onvio.reports.firmManagementReports.FirmManagementReportsListController as vm',
                resolve: {
                    'resolve.translationsLoaded': [
                        '$translate',
                        function($translate) {
                            // #WORKAROUND ensures all translations are loaded before the controller runs.
                            return $translate('Bluemoon.Practice.Common.ErrorHandler.GenericValidationError');
                        }
                    ]
                }
            });

            $stateProvider.state('firm-management-reports-options-add', {
                url: '/firm-management-reports-options-add/:reportId',
                templateUrl: 'reports/firm-management-reports/firm-management-reports-options.html',
                controller: 'onvio.reports.firmManagementReports.FirmManagementReportsOptionsController as vm',
                resolve: {
                    'resolve.translationsLoaded': [
                        '$translate',
                        function($translate) {
                            // #WORKAROUND ensures all translations are loaded before the controller runs.
                            return $translate('Bluemoon.Practice.Common.ErrorHandler.GenericValidationError');
                        }
                    ]
                }
            });

            $stateProvider.state('firm-management-reports-options', {
                url: '/firm-management-reports-options/:reportId/:employeeReportOptionId',
                templateUrl: 'reports/firm-management-reports/firm-management-reports-options.html',
                controller: 'onvio.reports.firmManagementReports.FirmManagementReportsOptionsController as vm',
                resolve: {
                    'resolve.translationsLoaded': [
                        '$translate',
                        function($translate) {
                            // #WORKAROUND ensures all translations are loaded before the controller runs.
                            return $translate('Bluemoon.Practice.Common.ErrorHandler.GenericValidationError');
                        }
                    ]
                }
            });
        }]);
})(window.angular);
